export const makeTag = ({ id, name, planId, createdAt }) => ({
  id,
  name,
  planId,
  createdAt,
})
